/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StoreItemsResponse } from '../model/storeitemsresponse';
import { StoreCategoriesResponse } from '../model/storecategoriesresponse';
import { StoreItemFilterInfo } from '../model/storeitemfilterinfo';
import { StoreCapableItemTypesResponse } from '../model/storecapableitemtypesresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";

@Injectable()
export class StoreItemsService {

  private _storeCount = new Subject<number>();

  constructor(public http: HttpClient) {
  }

  // Get call to fetch store item details
  public getStoreItems(offset: number, limit: number, sortBy: string,
    sortOrder: string, storeItemFilterInfo: StoreItemFilterInfo): Observable<StoreItemsResponse> {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder);
    let data = this.http.post<StoreItemsResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
      + '/customer/stores/storeitems', storeItemFilterInfo, { params })
      .pipe(tap(resp => {
        this._storeCount.next(resp.resultCount);
      }
      )
      );
    return data;
  }

  // Get call to fetch store categories
  public getStoreCategories() {
    return this.http.get<StoreCategoriesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/stores/storecategories');
  }

  // Get call to fetch store capable Item Types
  public getStoreCapableItemTypes() {
    return this.http.get<StoreCapableItemTypesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/stores/storecapableitemtypes');
  }

  public getStoreItemCount(): Observable<number> {
    return this._storeCount;
  }
}
